import { render, staticRenderFns } from "./UsersMetrics.vue?vue&type=template&id=00113c5c&scoped=true&"
import script from "./UsersMetrics.vue?vue&type=script&lang=js&"
export * from "./UsersMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00113c5c",
  null
  
)

export default component.exports